import { ActivatedRoute } from '@angular/router';
import { MainService } from 'src/app/Services/service.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-conversation',
  templateUrl: './conversation.component.html',
  styleUrls: ['./conversation.component.scss']
})
export class ConversationComponent implements OnInit {

  private activeConversationId: string;

  constructor(private service: MainService, private route: ActivatedRoute) {

    this.activeConversationId = this.route.snapshot.paramMap.get('id');
    service.pageName = "Inbox";

   }

  ngOnInit(): void {
  }

}
